import type { OutputCategory } from '@/lib/api';

/**
 * 目的カテゴリの表示定義。ラベルと色をここだけで持つ。
 * 色は意味に合わせてトークンを割り当てる（インシデントは error、負債・基盤は info）。
 */
/** @graph-connects none */
export const CATEGORY_DISPLAY: Record<OutputCategory, { label: string; color: string }> = {
  new_feature: { label: '新規機能', color: 'var(--color-success)' },
  improvement: { label: '改善', color: 'var(--color-primary)' },
  ops_efficiency: { label: '運用効率化', color: 'var(--color-secondary)' },
  platform: { label: '負債・基盤', color: 'var(--color-info)' },
  incident: { label: 'インシデント対応', color: 'var(--color-error)' },
  regulatory: { label: '制度改定', color: 'var(--color-warning)' },
  investigation: { label: '調査', color: 'var(--color-accent)' },
  external: { label: '外部協業', color: 'var(--color-text-secondary)' },
  unclassified: { label: '未分類', color: 'var(--color-text-disabled)' },
};

/** 積み上げの並び順。凡例・グラフ・表で同じ順序を使う */
/** @graph-connects none */
export const CATEGORY_ORDER: OutputCategory[] = [
  'platform',
  'ops_efficiency',
  'improvement',
  'new_feature',
  'incident',
  'regulatory',
  'investigation',
  'external',
  'unclassified',
];
